import React, { useEffect, useState, useContext } from 'react';
import "../../assets/ChDocPreviewOD/css/ChDocPreviewPage.scss"
import chLogo from '../../assets/ChDocPreviewOD/img/logo.png'
import { usePreviewData } from '../../Hooks/usePreviewData';
import { useHistory } from "react-router-dom";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import { useClaimReg } from "../../Hooks/useClaimReg";
import { usePageLoad } from "../../Hooks/usePageLoad";
import QueryStringContext from "../../Contexts/QueryString";
import { Helmet } from "react-helmet";
import Loader from '../Includes/Layouts/UFC_DC_RF_V1/Loader';

const ChDocPreviewOD = () => {

    const { getChDocPreviewData } = usePreviewData();
    const [userData, setUserData] = useState([]);
    const history = useHistory();
    const { visitorParameters } = useContext(VisitorParamsContext);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const { clickPreviewVisit } = useClaimReg();
    const { savePageLoad, calledOnce } = usePageLoad();
    const { queryString } = useContext(QueryStringContext);
    const [isDefaultViewport, setIsDefaultViewport] = useState(true);
    const [showLoader, setShowLoader] = useState("hide");

    let customUuid = "";
    const query = new URLSearchParams(window.location.search);
    const query_uuid = query.get("uuid");

    const local_uuid = localStorage.getItem("uuid");
    customUuid = query_uuid ? query_uuid : local_uuid;

    const allFollowupData = JSON.parse(
        localStorage.getItem("allFollowupData")
    );
    let split_name = localStorage.getItem("split_name");
    let t2aValidation = localStorage.getItem("t2aValidation");
    let userPreviousAddress = JSON.parse(localStorage.getItem("userPreviousAddress"));
    let uuid = visitorParameters?.visitor_parameters?.uuid;

    useEffect(() => {
        const formDataRaw = localStorage.getItem('formData');
        const parsedData = formDataRaw ? JSON.parse(formDataRaw) : null;
        let ip_address = visitorParameters?.data?.ip_address;

        if (parsedData) {
            const ucFirst = (str) => str
                ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
                : '';

            const clientName = `${ucFirst(parsedData?.txtFName)} ${ucFirst(parsedData?.txtLName)}`;

            const timeNow = new Date().toLocaleString().split(" ")[0].replace(/,/g, "");

            let dateParser = new Date(`${parsedData?.DobDay} ${parsedData?.DobMonth} ${parsedData?.DobYear}`);

            let monthValue =
                dateParser.getMonth() + 1 > 9
                    ? dateParser.getMonth() + 1
                    : `0${dateParser.getMonth() + 1}`;

            let dateValue = dateParser.getDate() > 9 ? dateParser.getDate() : `0${dateParser.getDate()}`;

            let dob = `${dateValue}/${monthValue}/${parsedData?.DobYear}`;
            let postcode = parsedData?.txtPostCode ? parsedData?.txtPostCode.toUpperCase() : "";
            let prevAddress = "";

            const currentAddressParts = [
                parsedData.txtHouseNumber,
                parsedData.txtAddress2,
                parsedData.txtAddress3,
                parsedData.txtTown,
                parsedData.txtCounty,
                parsedData.txtCountry,
                parsedData.txtPostCode ? parsedData.txtPostCode.toUpperCase() : ""
            ].filter(Boolean); // removes empty, null, undefined

            const currentAddress = currentAddressParts.join(', ');

            // if (parsedData.previous_postcode != undefined) {

            //     if (
            //         parsedData.previous_address_city !== "" ||
            //         parsedData.previous_address_city !== null
            //     ) {
            //         if (parsedData.previous_address_line1 !== null) {
            //             prevAddress += parsedData.previous_address_line1;
            //         }
            //         if (parsedData.previous_address_line2 !== "") {
            //             prevAddress += ", " + parsedData.previous_address_line2;
            //         }
            //         if (parsedData.previous_address_town !== "") {
            //             prevAddress += ", " + parsedData.previous_address_town;
            //         }
            //         if (parsedData.previous_address_county !== "") {
            //             prevAddress += ", " + parsedData.previous_address_county;
            //         }
            //         if (parsedData.previous_address_country !== "") {
            //             prevAddress += ", " + parsedData.previous_address_country;
            //         }
            //         if (parsedData.previous_postcode !== "") {
            //             prevAddress += ", " + parsedData.previous_postcode.toUpperCase();
            //         }
            //     }
            // }

            if (userPreviousAddress && Array.isArray(userPreviousAddress)) {
                let formattedPrevAddresses = userPreviousAddress.map((addressObj, index) => {
                    const parts = [
                        addressObj.txtPrevAddressLine1,
                        addressObj.txtPrevAddressLine2,
                        addressObj.txtPrevAddressLine3,
                        addressObj.txtPrevTown,
                        addressObj.txtPrevCounty,
                        addressObj.txtPrevCountry,
                        addressObj.txtPrevPostcode?.toUpperCase()
                    ].filter(Boolean); // removes null/undefined/empty

                    return `${parts.join(', ')}`;
                });
                formattedPrevAddresses.reverse();
                prevAddress = formattedPrevAddresses.join('\n\n');
            }

            const updatedData = {
                ...parsedData,
                client_name: clientName,
                sign_date: timeNow,
                dob: dob,
                postcode: postcode,
                address: currentAddress,
                prevAddress: prevAddress,
                ip_address: ip_address
            };
            setUserData(updatedData); // ✅ Clean single state update
        } else {
            fetchData();
        }
    }, []);


    const fetchData = async () => {
        const response = await getChDocPreviewData(customUuid);

        if (response) {
            let result = response?.data?.result;
            setUserData(result);
        }
    }


    const pushPageChange = async () => {
        setIsDefaultViewport(false);
        setBtnDisabled(true);
        setShowLoader("show");
        try {
            const previewresponse = await clickPreviewVisit(
                query_uuid,
                split_name,
                "ch_doc_preview_page",
                allFollowupData?.atp_sub6 ?? 'live'
            );
            if (previewresponse.data.status == "Success") {

                const data = {
                    uuid: visitorParameters.visitor_parameters.uuid,
                    page_name: "ch_doc_preview_page",
                    status: "completed",
                    source: allFollowupData?.atp_sub6 ?? 'regular',
                };
                (async () => {
                    await savePageLoad(
                        visitorParameters.visitor_parameters,
                        data,
                        "visited_status",
                        split_name,
                        queryString,
                        visitorParameters.data
                    );
                })();
                setTimeout(() => {
                    setShowLoader("hide");
                    // if (allFollowupData) {
                    //     window.scrollTo(0, 0);
                    //     history.push("/ThankyouODUFL4?uuid=" + query_uuid);
                    // } else {
                    //     if (userData?.t2a_status == "1" || t2aValidation == '1') {
                    //         window.scrollTo(0, 0);
                    //         history.push("/ThankyouODUFL4?uuid=" + query_uuid);
                    //     } else {
                    //         window.scrollTo(0, 0);
                    //         history.push(
                    //             `/UFC_DC_V4_ID?uuid=${query_uuid}&split_name=${split_name}`
                    //         );
                    //     }
                    // }

                    window.scrollTo(0, 0);
                    history.push("/ThankyouODUFL4?uuid=" + query_uuid);
                }, 500);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        if (!!uuid && !calledOnce) {
            const data = {
                uuid,
                page_name: "ch_doc_preview_page",
                status: "visited",
                source: allFollowupData?.atp_sub6 ?? 'regular',
            };
            (async () => {
                await savePageLoad(
                    visitorParameters.visitor_parameters,
                    data,
                    "visited_status",
                    split_name,
                    queryString,
                    visitorParameters.data
                );
            })();
        }
    }, [uuid, calledOnce]);

    return (
        <>

            <Helmet>
                {isDefaultViewport ? (
                    <meta name="viewport" content="" />
                ) : (
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                )}
            </Helmet>

            <GetVisitorsParams />
            <div className="ChDocPreviewPage">
                <div className="a4-page">

                    <div className="header-section">
                        <div className="logo-box">
                            <img src={chLogo} alt="Charterhouse Claims Logo" className="logo-image" />

                        </div>
                        <div className="separator"></div>
                        <h1 className="letter-title">Letter of Authority</h1>
                    </div>

                    <div className="form-section">
                        <div className='container'>
                            <div className="row">
                                <div className="col-md-6 d-flex flex-column mb-4">
                                    <div className="form-group">
                                        <label for="clientName" className="form-label">Client Name:</label>
                                        <input type="text" className="form-control" id="clientName" value={userData?.client_name || ''} disabled />
                                    </div>
                                    <div className="form-group">
                                        <label for="previousName" className="form-label">Previous Name:</label>
                                        <input type="text" className="form-control" id="previousName" value={userData?.Previousname || userData?.previous_name || ''} disabled />
                                    </div>
                                    <div className="form-group">
                                        <label for="dateOfBirth" className="form-label">Date of Birth:</label>
                                        <input type="text" className="form-control" id="dateOfBirth" value={userData?.dob || ''} disabled />
                                    </div>
                                    <div className="form-group">
                                        <label for="financeCompany" className="form-label">Finance Company:</label>
                                        <input type="text" className="form-control" id="financeCompany" value={''} disabled />
                                    </div>
                                </div>


                                <div className="col-md-6 d-flex flex-column">
                                    <div className="form-group">
                                        <label for="currentAddress" className="form-label">Current Address:</label>
                                        <textarea className="form-control" id="currentAddress" rows="2" value={userData?.address || ''} disabled ></textarea>
                                    </div>
                                    <div className="form-group">
                                        <label for="previousAddresses" className="form-label">Previous Address(es):</label>
                                        <textarea className="form-control" id="previousAddresses" rows="2" value={userData?.prevAddress || ''} disabled ></textarea>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    {/* <div className="body-text-section">
                        <p><strong>To whom it may concern: This authority relates to all matters concerning the finance I had/have with your company.</strong></p>
                        <p><strong>1.</strong> I hereby appoint and expressly authorise <strong>Charterhouse Claims Ltd</strong> trading as Charterhouse ('the Company') registered in England and Wales <strong>No 07300271, FCA reference number 832999</strong> to consider my Mis-Sold Car Finance claim and if the company believes that the claim has merits, act on my behalf to seek Compensation. <strong>2.</strong> I hereby confirm that this authority shall remain unless I advise otherwise, or all claims being handled by the Company have been completed. <strong>3.</strong> I further authorise and insist that as applicable (a) advisor(s) and or b)financier(s) and/or or(c) arranger(s) of the Finance (together 'the Relevant Parties') release to the Company any information, whether deemed confidential or otherwise, as may be requested from time to time by the Company, by telephone or in writing (including by fax or e mail), which would include any sales recording undertaken at the time of sale, held in whatever format and to do so without delay. I further authorise Charterhouse to raise an information request to the Lender, by way of a Subject Access Request pursuant to <strong>Article 15 of the retained Regulation (EU) 2016/679 [UK GDPR]</strong>, where necessary to substantiate my claim and/or to request information about add-on products financed under my credit agreement with the Lender. <strong>4.</strong> I confirm that I have lawfully contracted with the Company and have expressly consented that all communications from you must be made to me, and a copy forwarded to the Company. A copy of this Letter of Authority shall have the same validity as the original. <strong>5.</strong> I authorise Charterhouse to conduct any relevant checks in relation to my claim. <strong>6.</strong> I authorise Charterhouse to refer the complaint to The Financial Ombudsman Service if settlement cannot be agreed. This appointment is made pursuant to <strong>FCA Rule Disp 2.7.2R</strong>. The appointment endures until cancellation in writing or by settlement of any claim, whichever the earlier. <strong>7.</strong> I confirm that any Claim Testimony information provided is accurate to the best of my belief. <strong>8.</strong> I hereby confirm that all correspondence, documentation and offers of settlement should be directed or copied to Charterhouse. I have authorised Charterhouse to communicate the acceptance or declinature of any offer of compensation received on the Applicant's behalf. I hereby authorise Charterhouse to receive any payment made, arising out of the complaint, into Charterhouse Claims FCA regulated client bank account (presently sort code <strong>20-01-96 account number 33767930</strong>). I further authorise Charterhouse to deduct its fees as permitted within CMCOB rules (as in force). Charterhouse Claims correspondence address is Charterhouse Claims Ltd, 145 Washway Road, Sale, M33 7PE You should only sign this document if you have read and agree to the Letter of Authority (this document), <a href="https://charterhouseclaims.com/terms-and-conditions/">Terms and Conditions</a> and the Company's <a href="https://charterhouseclaims.com/privacy-policy/">Privacy Policy</a>.</p>

                        <div className="signature-section">
                            <div>
                                <label for="signature" className="form-label">Signature:</label>
                                <img className="form-control" style={{ height: "133px", maxwidth: "80%" }} src={userData?.user_sign || userData?.signature || ''} />
                            </div>
                            <div>
                                <label for="dateOfSignature" className="form-label">Date of Signature:</label>
                                <input type="text" className="form-control" id="dateOfSignature" value={userData?.sign_date || ""} disabled />
                            </div>
                        </div>
                    </div> */}




                    <div className="body-text-section">
                        <ul>
                            <li>I appoint and authorise Charterhouse Claims Ltd (FRN – 832999) ‘The Company’ as my sole representative in relation to pursuing all of my ‘Car Finance Claims’ Claim (s) and confirm that this authority shall remain unless I advise otherwise, or all claims have been concluded.</li>
                            <li>This authority relates to all information held for all ‘credit agreements’ with the above ‘Lender’.</li>
                            <li>I have read and agree to Charterhouse Claims ‘The Company’ documentation including terms and conditions, and privacy policy.</li>
                            <li>I confirm that any Claim Testimony (s) or information provided is accurate to the best of my belief.</li>
                            <li>I hereby confirm that all correspondence, documentation and offers of settlement should be directed or copied to Charterhouse. I have authorised Charterhouse to communicate the acceptance or declinature of any offer of compensation received on my behalf.</li>
                            <li>I further authorise Charterhouse to raise an information request to the ‘Lender’, by way of a Subject Access Request pursuant to Article 15 of the retained Regulation (EU) 2016/679 (UK GDPR), where necessary for disclosure of any information or documentation deemed relevant to my Claim (s), which is to be provided and released to Charterhouse Claims.</li>
                            <li>I authorise Charterhouse to refer the complaint to The Financial Ombudsman Service if settlement cannot be agreed. This appointment is made pursuant to FCA Rule Disp 2.7.2R.</li>
                            <li>I hereby authorise Charterhouse to receive any payment made, arising out of the complaint, into Charterhouse Claims FCA regulated client bank account:</li>
                        </ul>
                        <li style={{ listStyle: 'none', marginLeft: '32px' }}>Account Name: Charterhouse Claims Limited<br />
                            Sort Code: 20-01-96<br />
                            Account Number: 33767930</li><br />
                        <ul>
                            <li>I authorise Charterhouse to deduct its fees as permitted within CMCOB rules (as in force).</li>
                        </ul>
                        <p>You should only sign this document if you have read and agree to the Letter of Authority (this document), <a href="https://charterhouseclaims.com/terms-and-conditions/">Terms and Conditions</a> and the Company's <a href="https://charterhouseclaims.com/privacy-policy/">Privacy Policy</a>.</p>

                        <div className="signature-section">
                            <div>
                                <label for="signature" className="form-label">Signature:</label>
                                <img className="form-control" style={{ height: "133px", maxwidth: "80%" }} src={userData?.user_sign || userData?.signature || ''} />
                            </div>
                            <div>
                                <label for="dateOfSignature" className="form-label">Date of Signature:</label>
                                <input type="text" className="form-control" id="dateOfSignature" value={userData?.sign_date || ""} disabled />
                            </div>
                        </div>
                            <p class="mt-3">Charterhouse Claims Limited is authorised and regulated by the Financial Conduct Authority
                            (FCA) for regulated claims management services. Our reference number is: 832999. You can
                            check this on Financial Services Register at <a href="https://register.fca.org.uk" target="_blank">https://register.fca.org.uk</a> Trading and Registered
                            address Stafford Court, 145 Washway Road, Sale, M33 7PE. Registered in England & Wales
                            Number 07300271.</p>
                    </div>


                </div>
                <hr className="page2-hr" />
                <div className="a4-page a4-page-2">
                    <h4 className="page2-header">Car Finance Customer Consent Form</h4>

                    <div className="page2-intro">
                        <p>TMS Legal Ltd</p>
                        <p>Name of Client:</p>
                        <p>Address:</p>
                    </div>

                    <div className="page2-content mt-5">
                        <p>I authorise the Processing Parties to share and transmit all information about me related to my claim for Mis-Sold Car Finance with the purpose of advancing the claim.</p>
                        <p>I understand that TMS Legal Ltd will introduce me to their partner firm, Charterhouse Claims Ltd to pursue my Mis-Sold Car Finance claim on my behalf.</p>
                        <p>I authorise Charterhouse Claims Ltd to run a soft credit check on my behalf and understand this will **not** affect my credit score.</p>
                    </div>

                    <div className="page2-signature-box">
                        <div className="form-group">
                            <label for="printName" className="form-label">PRINT NAME:</label>
                            <input type="text" className="form-control" id="printName" value={userData?.client_name || ''} disabled />
                        </div>

                        <div className="page2-signature-grid">
                            <div className="form-group">
                                <label for="signature2" className="form-label">SIGNATURE:</label>
                                <img className="form-control" style={{ maxwidth: "80%" }} src={userData?.user_sign || userData?.signature || ''} />
                            </div>
                            <div className="form-group">
                                <label for="dateOfSignature2" className="form-label">DATE OF SIGNATURE:</label>
                                <input type="text" className="form-control" id="dateOfSignature2" value={userData?.sign_date || ""} disabled />
                            </div>
                        </div>
                    </div>

                    <hr className="page2-hr" />

                    <h5 className="page2-withdrawal-heading">Withdrawal of Consent Form</h5>

                    <div className="page2-content">
                        <p>If you decide to revoke your consent for any of the Processing Parties to hold or process your data, you have the right to do so at any time. To exercise this right, please notify us via post or email</p>
                        <p className="page2-contact-details">
                            Our contact details are: -<br />
                            Address: FAO Consent Team, TMS Legal Ltd, 1 Poole Rd, Bournemouth, BH2 5QQ<br />
                            Email: <a href="mailto:info@moneysolicitor.com">info@moneysolicitor.com</a>
                        </p>
                    </div>

                    <div className="page2-footer-legal">
                        <p>
                        TMS Legal Ltd is a limited company registered in England and Wales under company no: 10315962 Its registered office is Arena, 9 Nimrod Way, Ferndown, BH21 7UH It is authorised and regulated by the Solicitors Regulation Authority, Number: 645041
                        </p>
                    </div>
                </div>

                <hr className="page2-hr" />

                <div className="a4-page">
                    <div className="header-section">
                        <div className="logo-box">
                            <img src={chLogo} alt="Charterhouse Claims Logo" className="logo-image" />
                        </div>
                        <div className="separator"></div>
                        <h1 className="letter-title">Certificate<br />of Authenticity</h1>
                    </div>

                    <div className="certificate-main-content">
                        <p className="intro-text">This Certificate of Authenticity is to confirm the following client digitally signed documentation through <a href="https://charterhouseclaims.co.uk" target="_blank">charterhouseclaims.co.uk</a> with the following details.</p>

                        <div className="row">
                            <div className="col-md-6 d-flex flex-column">
                                <div className="form-group">
                                    <label for="clientFullName" className="form-label">Client Full Name:</label>
                                    <input type="text" className="form-control" id="clientFullName" value={userData?.client_name || ''} disabled />
                                </div>
                                <div className="form-group">
                                    <label for="clientPhoneNumber" className="form-label">Client Phone Number:</label>
                                    <input type="text" className="form-control" id="clientPhoneNumber" value={userData?.txtPhone || userData?.telephone || ''} disabled />
                                </div>
                                <div className="form-group">
                                    <label for="signature3" className="form-label">Signature:</label>
                                    <img className="form-control" style={{ height: "133px", maxwidth: "80%" }} src={userData?.user_sign || userData?.signature || ''} />
                                </div>
                            </div>

                            <div className="col-md-6 d-flex flex-column">
                                <div className="form-group">
                                    <label for="clientEmailAddress" className="form-label">Client Email Address:</label>
                                    <input type="text" className="form-control" id="clientEmailAddress" value={userData?.txtEmail || userData?.email || ''} disabled />
                                </div>
                                <div className="form-group">
                                    <label for="clientPostcode" className="form-label">Client Postcode:</label>
                                    <input type="text" className="form-control" id="clientPostcode" value={userData?.postcode || ''} disabled />
                                </div>
                                <div className="form-group">
                                    <label for="documentSigned" className="form-label">Document Signed:</label>
                                    <input type="text" className="form-control" id="documentSigned" value={userData?.sign_date || ""} disabled />
                                </div>
                                <div className="form-group">
                                    <label for="ipAddress" className="form-label">I.P Address:</label>
                                    <input type="text" className="form-control" id="ipAddress" value={userData.ip_address && userData.ip_address !== "UNKNOWN" ? userData.ip_address : ''}
                                        disabled />
                                </div>
                            </div>
                        </div>

                        <p className="disclaimer-text">By using a digital signature, you understand that it holds the same legal validity as a physical signature and constitutes your consent to the contents of this document.</p>
                        <p className="instruction-text">Keep this certificate for your records as proof of your genuine involvement in the signing of the online form.</p>
                    </div>

                    <div className="certificate-footer-legal">
                        Charterhouse Claims Limited is authorised and regulated by the Financial Conduct Authority (FCA) for regulated claims management services. Our reference number is: 832999. You can check this on Financial Services Register at <a href="https://register.fca.org.uk" target="_blank">https://register.fca.org.uk</a>. Registered address: Charterhouse Claims LTD, Stafford Court, 145 Washway Road, Sale, Manchester, M33 7PE.
                    </div>
                </div>

                <div className="sticky-footer-button-container">
                    <a className="sticky-footer-button anim_ylw" onClick={() => pushPageChange()} disabled={btnDisabled}>Next</a>
                </div>
            </div>
            <div className="loader-container">
                <Loader showLoader={showLoader} />
                </div>

        </>
    )
}

export default ChDocPreviewOD;